import React, { useEffect, useState } from 'react';
import { ContentHeader, Table } from '@app/shared';
import { CalendarTypes } from './CalendarTypes';
import { useCalendars } from '@app/sdk';
import { ComponentErrorBoundary, toFormattedDate } from '@app/utilities';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { CalendarForm } from './CalendarForm';
import { ColDef } from 'ag-grid-community';
import { CalendarModel } from '@app/models';

export type CalendarFormModel = {
  id?: string;
  type?: string;
  startDate: string;
  endDate: string;
  nonWorkingDays: string[];
  holidays: string;
};

export function Calendars() {
  const [selectedCalendarType, setSelectedCalendarType] = useState(undefined as any);
  const { data: calendars } = useCalendars({ calendarType: selectedCalendarType });
  const [selectedCalendar, setSelectedCalendar] = useState<CalendarModel>(undefined);
  const [calendar, setCalendar] = useState<CalendarFormModel>(undefined);
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'nonWorkingDays', headerName: 'Non Working Days' },
    { field: 'startDate', headerName: 'Start Date' },
    { field: 'endDate', headerName: 'End Date' },
    { field: 'holidays', headerName: 'Holidays' },
  ];

  useEffect(() => {
    if (!selectedCalendar) {
      setCalendar(null);
      return;
    }
    const cal = {
      ...selectedCalendar,
      type: selectedCalendarType,
      startDate: toFormattedDate(selectedCalendar.startDate),
      endDate: toFormattedDate(selectedCalendar.endDate),
      nonWorkingDays: selectedCalendar.nonWorkingDays,
      holidays: selectedCalendar.holidays.map((h) => toFormattedDate(h)).join('\n'),
    };
    setCalendar(cal);
  }, [selectedCalendar, selectedCalendarType]);

  useEffect(() => {
    setSelectedCalendar(undefined);
  }, [selectedCalendarType]);

  const master = (
    <>
      <ContentHeader>
        Calendar Types
        <button className={'ui button'} onClick={() => setSelectedCalendar(undefined)} disabled>
          Add Calendar
        </button>
      </ContentHeader>
      <CalendarTypes selectedCalendarType={selectedCalendarType} setSelectedCalendarType={setSelectedCalendarType} />
      <div style={{ height: 'calc(100% - 200px)' }}>
        <Table items={calendars} onSelectItem={setSelectedCalendar} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <div className={'ui segment'}>
      {' '}
      <CalendarForm key={JSON.stringify(calendar)} calendar={calendar} selectedCalendarType={selectedCalendarType} />
    </div>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
